"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var Types_1 = require("Tokens/Types");
var classnames_1 = __importDefault(require("classnames"));
var rowAdderCssClass = "table-widget__row-adder";
exports.default = (function (props) {
    if (props.tokensEnabled === Types_1.TokensEnableState.Disabled) {
        return react_1.default.createElement(SingleOptionRowAdder, __assign({}, props));
    }
    else {
        return react_1.default.createElement(MultiOptionRowAdder, __assign({}, props));
    }
});
var SingleOptionRowAdder = function (props) {
    return (react_1.default.createElement("div", { className: "".concat(rowAdderCssClass), onClick: props.addRow, style: props.style },
        react_1.default.createElement("div", { className: "".concat(rowAdderCssClass, "-icon") },
            react_1.default.createElement(icons_1.Add, { size: icons_1.IconSize.Small }))));
};
var MultiOptionRowAdder = function (props) {
    var _a;
    var _b = __read((0, react_1.useState)(false), 2), isOpen = _b[0], setIsOpen = _b[1];
    var setOpen = function () {
        setIsOpen(true);
    };
    var setClosed = function () {
        setIsOpen(false);
    };
    var buttonClasses = (0, classnames_1.default)(rowAdderCssClass, (_a = {},
        _a["".concat(rowAdderCssClass, "--active")] = isOpen,
        _a));
    var preventFocus = function (e) {
        e.preventDefault();
    };
    return (react_1.default.createElement(kaleidoscope_1.OptionMenu, { button: react_1.default.createElement("div", { className: buttonClasses, style: props.style, onClick: setOpen },
            react_1.default.createElement("div", { className: "".concat(rowAdderCssClass, "-icon") },
                react_1.default.createElement(icons_1.Add, { size: icons_1.IconSize.Small }))), theme: kaleidoscope_2.OptionMenuTheme.Dark, className: "".concat(rowAdderCssClass, "-menu"), onClose: setClosed },
        react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { onClick: props.addRow, icon: react_1.default.createElement(icons_1.ListMarkerDash, null) },
            react_1.default.createElement("span", { onMouseDown: preventFocus }, "Regular Row")),
        react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { onClick: props.addRepeatingRow, icon: react_1.default.createElement(icons_1.Loop, null) },
            react_1.default.createElement("span", { onMouseDown: preventFocus }, "Repeating Row"))));
};
